import React from "react";

import SVG from "../SVG";

export default SVG(() => (
  <svg viewBox="0 0 16 16" fill="none">
    <path
      d="M12 6L8 10L4 6"
      stroke="#02BA44"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
));
